import moment from 'moment';

export const costReg = /^0\.([1-9]|[0-9][1-9])$|(^([1-9][0-9]{0,5})(\.[0-9]||\.[0-9][0-9])?$)/;
export const skuPalletReg = /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/;
export const integerReg = /^([1-9][0-9]{0,4})$/;

const skuPalletValidator = (rule, value, callback) => {
    if (!skuPalletReg.test(value)) {
        callback('请输入0.01-100的拍数');
    } else {
        callback();
    }
};
const integerValidator = (rule, value, callback) => {
    if (!integerReg.test(value)) {
        callback('请输入1-99999的箱数');
    } else {
        callback();
    }
};

export const haveWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '预计送达时间',
        dataIndex: 'arriveTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '供应商',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' },
        width: 180
    },
    {
        title: '始发地',
        dataIndex: 'originalSupplier',
        customRender: (text) => text || '-',
        width: 120
    },
    {
        title: '区域',
        dataIndex: 'area',
        width: 120
    },
    {
        title: '仓库',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' },
        width: 180
    },
    {
        title: '最终目的地',
        dataIndex: 'originalDepot',
        customRender: (text) => text || '-',
        width: 180
    },
    {
        title: '拍数',
        dataIndex: 'skuPallet',
        width: 60
    },
    {
        title: '箱数',
        dataIndex: 'skuAmount',
        width: 60
    },
    {
        title: '拍数向上取整',
        dataIndex: 'skuPalletUpper',
        width: 120
    }
];

export const haveAllWiringColumns = [
    {
        title: '出发地',
        dataIndex: 'fromSiteCode',
        // customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 150
    },
    {
        title: '原始出发地',
        dataIndex: 'originalFromSiteCode',
        // customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 150
    },
    {
        title: '目的地',
        dataIndex: 'destinationOrg',
        // customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 150
    },{
        title: '原始目的地',
        dataIndex: 'originalDestinationOrg',
        // customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 150
    },
    {
        title: '拍数',
        dataIndex: 'pallet',
        // customRender: (value, row) => {
        //     const val = row.bulkloadVolume;
        //     console.log(111, val);

        //     const obj = {
        //         children: val && val !== '0' ? 0 : row.palletRoUp,
        //         // children: this.totalSkuPallet(row.lineCode),
        //         attrs: {}
        //     };
        //     // obj.attrs.rowSpan = row.rowSpan;
        //     return obj;
        // },
        // customRender: (value, row) => {
        //     const val = row.vehiclePalletCount * row.vehicleLoadingRate;
        //     const obj = {
        //         children: val,
        //         // children: this.totalSkuPallet(row.lineCode),
        //         attrs: {}
        //     };
        //     // obj.attrs.rowSpan = row.rowSpan;
        //     return obj;
        // },
        width: 120
    },
    {
        title: '箱数',
        dataIndex: 'totalCase',
        // scopedSlots: { customRender: 'orderCode' },
        // customRender: (text) => text || '--',
        width: 120
    },
    {
        title: '方量（m³)',
        dataIndex: 'bulkloadVolume',
        // customRender: (text) => text || '--',
        width: 120
    },
    {
        title: '拍数向上取整',
        dataIndex: 'palletRoUp',
        width: 120
    }
];

const carList = [
    {
        value: '4.2米',
        label: '4.2米'
    },
    {
        value: '5.2米',
        label: '5.2米'
    },
    {
        value: '6.2米',
        label: '6.2米'
    },
    {
        value: '7.6米',
        label: '7.6米'
    },
    {
        value: '9.6米',
        label: '9.6米'
    },
    {
        value: '12.5米',
        label: '12.5米'
    },
    {
        value: '13.5米',
        label: '13.5米'
    },
    {
        value: '15米',
        label: '15米'
    },
    {
        value: '16.5米',
        label: '16.5米'
    }
];

export const carLengthList = carList;

export const notWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '集散中心',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' }
        // width:180
    },
    {
        title: '仓库',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' }
        // width:180
    },
    {
        title: '拍数',
        dataIndex: 'skuPallet',
        width: 140
    },
    {
        title: '箱数',
        dataIndex: 'skuAmount',
        width: 140
    },
    {
        title: '拍数向上取整',
        dataIndex: 'skuPalletUpper',
        width: 140
    }
    // {
    //   title:"未排线原因",
    //   dataIndex:"remark"
    // },
    // {
    //   title:"操作",
    //   dataIndex:"action",
    //   scopedSlots: { customRender: "action" },
    //   fixed:'right',
    //   width:120
    // }
];
// 排线编辑验证
export const EditWiringRules = {
    planTime: {
        RULES: [{ required: true, message: '请选择日期', trigger: 'change' }]
    },
    supplierCode: {
        RULES: [{ required: true, message: '请输入供应商', trigger: 'change' }]
    },
    warehouseCode: {
        RULES: [{ required: true, message: '请输入仓库', trigger: 'change' }]
    },
    skuPallet: {
        RULES: [
            { required: true, message: '请输入拍数', trigger: 'change' },
            { validator: skuPalletValidator, trigger: 'change' }
        ]
    },
    skuAmount: {
        RULES: [
            { required: true, message: '请输入箱数', trigger: 'change' },
            { validator: integerValidator, trigger: 'change' }
        ]
    }
};
// 编辑排线table
export const EditWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        key: 'planTime',
        scopedSlots: { customRender: 'planTime' },
        type: 'date',
        width: 160,
        prop: {}
    },
    {
        title: '供应商',
        key: 'supplierCode',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' },
        type: 'input',
        width: 160,
        prop: {
            maxLength: 100,
            placeholder: '请输入供应商'
        }
    },
    {
        title: '仓库',
        key: 'warehouseCode',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' },
        type: 'input',
        width: 160,
        prop: {
            maxLength: 100,
            placeholder: '请输入仓库'
        }
    },
    {
        title: '拍数',
        key: 'skuPallet',
        dataIndex: 'skuPallet',
        scopedSlots: { customRender: 'skuPallet' },
        type: 'numInput',
        width: 160,
        prop: {
            placeholder: '请输入拍数'
        }
    },
    {
        title: '箱数',
        key: 'skuAmount',
        dataIndex: 'skuAmount',
        scopedSlots: { customRender: 'skuAmount' },
        type: 'numInput',
        width: 160,
        prop: {
            placeholder: '请输入箱数'
        }
    },
    {
        title: '拍数向上取整',
        key: 'skuPalletUpper',
        dataIndex: 'skuPalletUpper',
        width: 120
    },
    {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        width: 80,
        align: 'center'
    }
];

// 排线类型
export const PLAN_STATUS = {
    TO_BE_PLAN: 'TO_BE_PLAN', // 未排线
    PLANED: 'PLANED', // 已排线
    DELETED: 'DELETED'
};

// 装载拍数
export const CAR_LENGTH_VOLUME = {
    '7.6米': 10,
    '9.6米': 14,
    '12.5米': 18,
    '13.5米': 20,
    '15米': 22
};

export const SearchFiled = [
    {
        label: '出发地',
        name: 'fromSiteCode',
        type: 'input',
        prop: {
            placeholder: '请输入出发地编码',
            maxLength: 100
        }
    },
    {
        label: '目的地',
        name: 'destinationOrg',
        type: 'input',
        prop: {
            placeholder: '请输入目的地编码',
            maxLength: 100
        }
    },
    {
        label: '车长',
        name: 'vehicleType',
        type: 'select',
        prop: {
            placeholder: '请选择车长',
            // mode: 'multiple',
            options: carList
        }
    }
];
